/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCalendarDue = createReactComponent("calendar-due", "IconCalendarDue", [
  [
    "path",
    {
      d: "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M16 3v4", key: "svg-1" }],
  ["path", { d: "M8 3v4", key: "svg-2" }],
  ["path", { d: "M4 11h16", key: "svg-3" }],
  ["path", { d: "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-4" }]
]);

export { IconCalendarDue as default };
//# sourceMappingURL=IconCalendarDue.js.map
